import { InputNumberProps } from 'antd';
import { StyledInputNumber } from './InputStyles';

export type TInputNumberProps = InputNumberProps;

const InputNumber = ({ prefix, value, min = 0, ...props }: TInputNumberProps) => (
  <StyledInputNumber {...props} value={value} prefix={prefix} min={min} inputMode="numeric" />
);

export default InputNumber;
